(() => {
  const init = (root = document) => {
    root.querySelectorAll('.oak-latest').forEach(section => {
      if (section.dataset.oakReady) return;
      section.dataset.oakReady = 'true';
      const filters = section.querySelector('.oak-filters');
      if (!filters) return;
      filters.hidden = false;
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-oak-filter]');
        if (!button) return;
        filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        let count = 0;
        section.querySelectorAll('[data-oak-topic]').forEach(story => {
          story.hidden = button.dataset.oakFilter !== 'all' && story.dataset.oakTopic !== button.dataset.oakFilter;
          if (!story.hidden) count++;
        });
        section.querySelector('[data-oak-filter-status]').textContent = `${count} ${count === 1 ? 'story' : 'stories'} shown.`;
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
